import './FormActionExtract.css';
import TextInput from '/src/components/UI/TextField/TextInput';
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import ActionExtractType from '../../../data/constant/types/ActionExtractType';
import ActionExtractBeforeAfter from '../../../data/constant/types/ActionExtractBeforeAfter';
import VariableDropdown from '../../Variables/VariablesDropdown/VariablesDropdown';
import InputBox from '/src/components/UI/InputBox/InputBox';
import TitleBlock from '../TitleBlock/TitleBlock';
import { useForm } from 'react-hook-form';
import { useState, useEffect, useMemo } from 'react';
import editorAction from '../../../actions/editorAction';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import binarySearchString from '../../../utils/binarySearchString';
import { BlockActionExtractDefault } from '../../../data/constant/blocks/BlockActionExtractDefault';

function FormActionExtract( { id }) {

    const { blocks } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ?  blocks[indexBlock] : BlockActionExtractDefault
    const name = block.name
    const {is_advance_extract, before_after, extract_input, extract_output, extract_type, keywords_exclude, keywords_include} = block.data
    

    const [isSetting, setIsSetting] = useState(is_advance_extract);

    const { updateBlockData } = editorAction();

    const { register, handleSubmit, watch, formState: { errors }, formState, getValues, setValue } = useForm({
		mode: "onBlur",
		defaultValues: {
            before_after : before_after == null ? 'before': before_after.name,
            extract_type : extract_type.name,
            extract_input,
            extract_output ,
            is_advance_extract : is_advance_extract ? 1 : 0,
            keywords_include,
            keywords_exclude
        }
	});

    const setDropdown = (name, value) => {
        setValue(name, value);
        onSubmit(getValues());
    }

    const changeInputBox = (name, value) => {
        setValue(name, value ? 1 : 0);
        setIsSetting(value);
        if(value == false) {
            setValue("before_after", 'before');
            const input = document.getElementsByName('before_after').item(0);
            input.nextElementSibling.firstElementChild.innerHTML = 'Before'
        }
        onSubmit(getValues());
    }

    const transformBlockName = (data) => {
        if(data.extract_input == null || (BlockActionExtractDefault.name != name && /^Extract from \[/.test(name) == false) ) return data
        data.name = `Extract from [${data.extract_input.name.toUpperCase()}]`
        return data
    }
    

    const onSubmit = (data) => {

        data = transformBlockName(data)

        var dataServer = {...data};
        if(data.extract_output == null) {
            delete data.extract_output
            delete dataServer.extract_output
        }
        else {
            dataServer.extract_output =  dataServer.extract_output.name
        }

        if(data.extract_input == null) {
            delete data.extract_input
            delete dataServer.extract_input
        }
        else {
            dataServer.extract_input =  dataServer.extract_input.name
        }

        data.extract_type = { name : data.extract_type }
        data.before_after = { name : data.before_after }

        updateBlockData(id, data, dataServer)
    }

    return (
        <>
            <TitleBlock title="Action Extract" titleInput="Extract name" name={name} id={id}/>
            <form className='area-edit'>
                <div className='grid-row' style={{ marginTop : "10px" }}>
                    <label className="dropdown_title">Extract : </label>
                    <div className='dropdown_container'>
                        <Dropdown {...register('extract_type')} choices={ActionExtractType} width="calc(100%)" setValue={setDropdown} defaultChoice={extract_type.name}/>
                    </div>
                </div>
                <div className='grid-row'>
                    <label className="dropdown_title">From : </label>
                    <div className='dropdown_container'>
                        <VariableDropdown register={register('extract_input')} variable={extract_input} setValue={setDropdown}/>
                    </div>
                </div>
                <div className='grid-row'>
                    <label className="dropdown_title">Save result in : </label>
                    <div className='dropdown_container'>
                        <VariableDropdown register={register('extract_output')} variable={extract_output} setValue={setDropdown}/>
                    </div>
                </div>
                <div className='grid-row'>
                    <label className="dropdown_title">Advanced settings : </label>
                    <div className='dropdown_container' style={{ display : 'flex', justifyContent : 'center'}}>
                        <InputBox id='is_advance_extract' {...register('is_advance_extract')} classNameLabel="inputBox-center" check={is_advance_extract} setValue={changeInputBox}></InputBox>
                    </div>
                </div>
                <div className={isSetting ? '' : 'hidden'}>
                    <div className='grid-row'>
                        <label className="dropdown_title">Extract Data : </label>
                        <div className='dropdown_container'>
                            <Dropdown {...register('before_after')} choices={ActionExtractBeforeAfter} width="calc(100%)" setValue={setDropdown} defaultChoice={before_after == null ? 'before' : before_after.name}/>
                        </div>
                    </div>


                    <label className="dropdown_title">Accepted keywords : </label>
                    <TextInput {...register('keywords_include')} onBlur={() => onSubmit(getValues())} className="editor-input title_input keyword" placeholder="keyword1; keyword2; keyword 3"/>

                    <div className='grid-row'></div>
                    <label className="dropdown_title">Forbidden keywords : </label>
                    <TextInput {...register('keywords_exclude')} onBlur={() => onSubmit(getValues())} className="editor-input title_input keyword" placeholder="keyword1; keyword2; keyword 3"/>
                </div>
            </form>
        </>
    )
}

export default FormActionExtract;